import { render, staticRenderFns } from "./capacitacion-coppast.vue?vue&type=template&id=5c1bdf38&"
import script from "./capacitacion-coppast.vue?vue&type=script&lang=js&"
export * from "./capacitacion-coppast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports